/** Thai VAT, in percent. Set by law rather than by the business, so it is not a system setting. */
export const VAT_RATE_PERCENT = 7;
